










































import Vue, { PropType } from 'vue';

interface Link {
  text: string;
  value?: number;
  to?: string | Location;
}

export interface TabOption {
  value: number;
  text: string;
  to: string | {
    name: string;
    query: {
      page: string;
      sub?: string;
      id?: string;
    };
  };
  validationId?: string;
}

interface Button {
  text: string;
  theme?: 'primary' | 'primary-outline' | 'sub';
  disabled?: boolean;
  withValidation?: boolean;
  onClick: () => void;
}

export default Vue.extend({
  name: 'GPageHeader',
  props: {
    currentPage: {
      type: String as PropType<string>,
      required: true,
    },
    headingTexts: {
      type: Array as PropType<Link[]>,
      default: () => [],
    },
    tabLinks: {
      type: Array as PropType<TabOption[]>,
      default: () => [],
    },
    tabOptions: {
      type: Array as PropType<TabOption[]>,
      default: () => [],
    },
    buttons: {
      type: Array as PropType<Button[]>,
      default: () => [],
    },
    isInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    spOptionValue: {
      get(): number {
        const tabOption = this.tabOptions.find((option) => {
          if (typeof option.to === 'string') {
            return this.$route.fullPath.includes(option.to);
          }
          if (option.to.query.sub) {
            return this.$route.fullPath.includes(option.to.query.page) && this.$route.fullPath.includes(option.to.query.sub);
          }
          if (option.to.query.page) {
            return this.$route.fullPath.includes(option.to.query.page);
          }
          return undefined;
        });
        if (!tabOption) return 0;
        return tabOption.value;
      },
      set(value: number | string) {
        const val = Number(value);
        const option = this.tabOptions.find((tabOption) => tabOption.value === Number(val));
        if (!option) return;
        const to = option.to;
        if (typeof to === 'string') {
          const currentPath = this.$route.fullPath;
          if (currentPath.includes(to)) return;
        }
        this.$router.push(to);
      },
    },
  },
});
